import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.css',
})
export class MenusComponent implements OnInit {
  isMobile = window.innerWidth <= 900;
  open = !this.isMobile && this.storageService.getWindowMode() !== 'false';
  langSelected = this.langService.getLang();

  constructor(
    public router: Router,
    private appComponent: AppComponent,
    public storageService: StorageService,
    private transloco: TranslocoService,
    private langService: LanguageService,
    private authService: AuthService,
  ) {}

  get sectionKey(): string {
    const route = this.router.url.split('?')[0].split('/')[1];
    const sections: Record<string, string> = {
      home: 'workspace.overview', devices: 'menus.devices', device: 'menus.devices',
      projects: 'menus.projects', project: 'menus.projects',
      report: 'menus.report', companies: 'menus.companies', company: 'menus.company',
      users: 'menus.users', user: 'menus.user', workers: 'menus.workers', worker: 'menus.workers',
      zones: 'menus.zones', zone: 'menus.zones', alarmConfiguration: 'menus.alarmConfiguration',
      faq: 'menus.faq', import: 'workers.import', billing: 'menus.facturacion',
    };
    return sections[route] ?? 'workspace.overview';
  }

  get roleKey(): string {
    return this.storageService.roleId === 1 ? 'workspace.superadmin'
      : this.storageService.roleId === 2 ? 'workspace.admin' : 'workspace.controller';
  }

  ngOnInit(): void {
    const session = this.storageService.hydrateSession();
    if (session) {
      this.appComponent.isAuthenticated = true;
      this.authService.scheduleRefresh();
      return;
    }
    if (!this.storageService.getRefreshToken()) {
      this.redirectToLogin();
      return;
    }
    this.authService.refreshSession().subscribe({
      next: () => {
        this.storageService.hydrateSession();
        this.appComponent.isAuthenticated = true;
        this.authService.scheduleRefresh();
      },
      error: () => this.redirectToLogin(),
    });
  }

  @HostListener('window:resize')
  changeMode(): void {
    const mobile = window.innerWidth <= 900;
    if (mobile !== this.isMobile) {
      this.isMobile = mobile;
      this.open = !mobile && this.storageService.getWindowMode() !== 'false';
    }
  }

  toggleOpen(isOpened: boolean): void {
    this.open = isOpened;
    if (!this.isMobile) this.storageService.setWindowMode(String(isOpened));
  }

  closeMobileMenu(): void {
    if (this.isMobile) this.open = false;
  }

  logout(): void {
    this.authService.clearSession();
    this.appComponent.isAuthenticated = false;
    this.router.navigate(['login']);
  }

  setLangSelected(): void {
    this.appComponent.langSelected = this.langSelected;
    this.langService.saveLang(this.langSelected);
    this.transloco.setActiveLang(this.langSelected);
    window.location.reload();
  }

  private redirectToLogin(): void {
    this.authService.clearSession();
    this.appComponent.isAuthenticated = false;
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
